import React, { useCallback, useMemo } from "react";
import { ExpandedConfigurationSection, InputsActions } from "components/inputs/InputsOveriew";
import MessagesPerStreamSection from "components/inputs/InputsOveriew/expanded-sections/MessagesPerStreamSection";
import ExtractorsSection from "components/inputs/InputsOveriew/expanded-sections/ExtractorsSection";
import ExtractorsSectionActions from "components/inputs/InputsOveriew/expanded-sections/ExtractorsSectionActions";
import AssociatedStreamsSection from "components/inputs/InputsOveriew/expanded-sections/AssociatedStreamsSection";
import { METRIC_COLUMN_IDS, METRIC_COLUMN_TITLES } from "components/inputs/InputsOveriew/metricColumns";
const useTableElements = ({
  inputTypeDescriptions,
  inputTypes
}) => {
  const entityActions = useCallback(
    (listItem) => /* @__PURE__ */ React.createElement(InputsActions, { input: listItem, inputTypes, inputTypeDescriptions }),
    [inputTypes, inputTypeDescriptions]
  );
  const renderExpandedConfigurationDetails = useCallback(
    (input) => /* @__PURE__ */ React.createElement(ExpandedConfigurationSection, { input, inputTypeDescriptions }),
    [inputTypeDescriptions]
  );
  const expandedSections = useMemo(
    () => ({
      configuration: {
        title: "Configuration",
        content: renderExpandedConfigurationDetails
      },
      [METRIC_COLUMN_IDS.messagesPerStream]: {
        title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.messagesPerStream],
        content: (input) => /* @__PURE__ */ React.createElement(MessagesPerStreamSection, { input })
      },
      [METRIC_COLUMN_IDS.extractorCount]: {
        title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.extractorCount],
        content: (input) => /* @__PURE__ */ React.createElement(ExtractorsSection, { input }),
        actions: (input) => /* @__PURE__ */ React.createElement(ExtractorsSectionActions, { input })
      },
      [METRIC_COLUMN_IDS.associatedStreams]: {
        title: METRIC_COLUMN_TITLES[METRIC_COLUMN_IDS.associatedStreams],
        content: (input) => /* @__PURE__ */ React.createElement(AssociatedStreamsSection, { input })
      }
    }),
    [renderExpandedConfigurationDetails]
  );
  return {
    entityActions,
    bulkActions: /* @__PURE__ */ React.createElement(React.Fragment, null, "bulk"),
    expandedSections
  };
};
export default useTableElements;
